//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMixin } from 'vuelidate';
import {
    required, email, minLength, url,
} from 'vuelidate/lib/validators';
import BaseAlert from '~/components/BaseAlert.vue';
import BaseSpinner from '~/components/BaseSpinner.vue';

export default {
    components: {
        BaseAlert,
        BaseSpinner,
    },

    mixins: [validationMixin],

    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        form: {
            data: {},
            loading: false,
        },
    }),

    validations: {
        form: {
            data: {
                message: { required, min: minLength(3) },
                name: { required, min: minLength(3) },
                email: { required, email },
                site: { url },
            },
        },
    },

    methods: {
        formOpen() {
            if (this.$el.classList.contains('open')) return;

            this.$el.classList.add('open');
            this.$el.querySelector('textarea').focus();
            document.body.addEventListener('click', this.formClose);
        },
        formClose(event) {
            const selfClicked = event.target.closest('.form-reply') === this.$el;

            if (selfClicked) return;

            this.$el.classList.remove('open');
            document.body.removeEventListener('click', this.formClose);
        },
        formSubmit() {
            this.$v.form.data.$touch();
            if (this.$v.form.data.$error) return;

            this.form.loading = true;

            this.$store.dispatch('data/postComment', {
                route: this.$route,
                index: this.data.index,
                params: {
                    singleId: this.data.singleId,
                    commentId: this.data.commentId,
                    ...this.form.data,
                },
            }).then((commentId) => {
                const elComment = document.getElementById(`comment-${commentId}`);

                this.form.data.message = null;
                this.$v.form.data.$reset();
                if (elComment) elComment.classList.add('highlight-background');
                setTimeout(() => this.$el.classList.remove('open'), 2000);
            }).catch(() => {
                // empty catch
            }).finally(() => {
                this.form.loading = false;
            });
        },
        getIdSuffix(string, commentId = this.data.commentId) {
            return (commentId && `${string}-${commentId}`) || string;
        },
    },
};
